import { render, staticRenderFns } from "./DisbursementInputTypeTextarea.vue?vue&type=template&id=652ba587&"
import script from "./DisbursementInputTypeTextarea.vue?vue&type=script&lang=js&"
export * from "./DisbursementInputTypeTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput})
